import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./ui/Button";
import { ButtonVariant } from "../types/constants";
import UserModel from "../models/UserModel";
import StarRatingSVG from "../custom-components/svg/functional-icons/StarRatingSVG";
import { useAuth } from "../context/AuthProvider";
// import FileIconSVG from "../custom-components/svg/functional-icons/SaveFileIconSVG";
import EditAccountData from "./EditAccountData";
// import AttachedFileIconSVG from "../custom-components/svg/functional-icons/AttachedFileIconSVG";
// import EventIconSVG from "../custom-components/svg/functional-icons/EventIconSVG";
// import { AccountData } from "./AccountData";
import { useState, } from "react";
import IconChevronUpSVG from "../custom-components/svg/functional-icons/IconChevronUpSVG";
import UploadingImageSVG from "./shared/svg/UploadingImageSVG";
import { Purpose } from "../domain/enums/Purpose";

interface AccountSectionProps {
    user: UserModel;
    imgSrc?: string;
    descriptionKey?: string;
    initialOpen?: boolean;
    onUserUpdated?: (user: UserModel) => void;
}

export default function AccountSection({
    user,
    descriptionKey,
    initialOpen = false,
    onUserUpdated,

}: AccountSectionProps) {
    const { t } = useTranslation();
    const { signOut } = useAuth();
    const [isEditing, setIsEditing] = React.useState(false);

    const classes = {
        img: "w-full h-full object-cover rounded-lg",
        text: "text-text-300 text-base font-normal w-full md:w-full lap:w-[160px] xl:w-[260px] xl:text-right",
    };

    const [state, setState] = useState({ open: initialOpen, spinning: false });
    const [accountUser, setAccountUser] = useState<UserModel>(user);

    React.useEffect(() => {
        setAccountUser(user);
    }, [user]);

    const handleUserUpdate = (updatedUser: any) => {
        const model = updatedUser instanceof UserModel ? updatedUser : new UserModel(updatedUser);
        setAccountUser(model);
        if (onUserUpdated) {
            onUserUpdated(model);
        }
    };

    const renderFooter = () => {
        return (
            <div className="w-full md:w-[700px] lg:w-[620px] flex flex-col md:flex-row lg:flex-row md:justify-between md:items-center mt-6 md:mt-0 gap-6">
                {/* <div className="w-full md:w-[180px] lg:w-[180px] md:h-auto flex flex-col lg:flex-row  px-1 py-1 gap-9">
                    {t("account.buttonText.share") && <Button text={t("account.buttonText.share")} variant={ButtonVariant.SHARE} />}
                    {descriptionKey && <p className={classes.text}>{t(descriptionKey)}</p>}
                </div> */}
                <div className="w-full md:w-[220px] lg:w-[220px] md:h-auto flex flex-col lg:flex-row  px-1 py-1 gap-9" onClick={signOut}>
                    {t("account.buttonText.exiteAccount") && <Button text={t("account.buttonText.exiteAccount")} variant={ButtonVariant.EXIT} />}
                    {descriptionKey && <p className={classes.text}>{t(descriptionKey)}</p>}
                </div>
            </div>
        );
    };

    return (
        <div className="flex flex-col">
            {isEditing && (
                <>
                    <EditAccountData
                        user={accountUser}
                        onClose={() => setIsEditing(false)}
                        onSave={handleUserUpdate}
                    />
                    {renderFooter()}
                </>

            )}
            {!isEditing && (
                <>
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between md:flex-row md:justify-between md:items-center mb-11 lg:mb-0 md:mb-0">
                        <h1 className="font-geologica text-3xl font-medium uppercase text-primary-400 flex flex-row justify-between items-center mb-9 lg:mb-0 md:mb-0">
                            {t("account.pageTitle")}
                        </h1>
                        <div className="lg:w-[175px] md:w-[175px] h-[50px] w-full flex flex-row justify-between items-center py-1 gap-6" onClick={() => setIsEditing(true)}>
                            {t("account.buttonText.edit") && <Button text={t("account.buttonText.edit")} variant={ButtonVariant.EDIT} />}
                            {descriptionKey && <p className={classes.text}>{t(descriptionKey)}</p>}
                        </div>

                    </div>

                    <div className="relative py-0 md:py-24 lg:py-8">
                        <div className="max-w-[1280px] mx-auto flex flex-col lap:flex-row  gap-12 xl:gap-[60px]">
                            <div className="w-[380px] h-[380px] md:w-[560px] md:h-[560px] lg:w-[620px] lg:h-[620px]
                        bg-background-100 border border-border-400 rounded-md px-6 py-6 md:px-8 md:py-8 flex items-center justify-center text-center gap-2 md:gap-5 shadow-[0px_6px_6px_0px_#36335214] border-2">
                                {accountUser.pictureExists(Purpose.AVATAR) ? (
                                    <img
                                        src={accountUser.getPictureUrl()}
                                        className=" object-cover w-[320px] h-[320px] md:w-[470px] md:h-[470px] lg:w-[520px] lg:h-[520px] "
                                    />
                                ) : (
                                    <div
                                        className="relative group cursor-pointer w-[320px] h-[320px] md:w-[470px] md:h-[470px] lg:w-[520px] lg:h-[520px] flex items-center justify-center rounded-md overflow-hidden bg-[#F8F8F8]"
                                    >
                                        <UploadingImageSVG classname="w-[100px] h-[80px] justify-self-center self-center" fill="#9F9F9F" strokeWidth={4.5} />
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-col gap-6">
                                <span className="lg:text-xl text-gray-400">{t("account.accountInformation.fullName")}</span>
                                <p className="lg:text-xl text-text-700">
                                    {[accountUser?.firstName, accountUser?.lastName, accountUser?.middleName]
                                        .filter(Boolean)
                                        .join(" ")}
                                </p>

                                {/* <span className="lg:text-xl text-gray-400">{t("account.accountInformation.rating")}</span>

                                <div className="flex gap-5">
                                    <p className="lg:text-xl text-text-700">{(accountUser.rating)}</p>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <StarRatingSVG key={index} />
                                    ))}
                                </div> */}

                                <span className="lg:text-xl text-gray-400">{t("account.accountInformation.accountDescription")}</span>

                                <div className="lg:w-[620px] md:w-[620px] w-full flex flex-col rounded-lg overflow-hidden bg-background-100">
                                    <div className="overflow-hidden">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setState((prev) => ({ ...prev, spinning: true, open: !prev.open }));
                                                window.setTimeout(() => setState((prev) => ({ ...prev, spinning: false })), 300);
                                            }}

                                            className="flex items-center justify-between w-full h-[50px] text-left"
                                        >
                                            <div className="flex flex-col items-start overflow-hidden pr-4 flex-1">
                                                {accountUser?.description ? (
                                                    !state.open && (
                                                        <p className="lg:text-xl text-text-700 font-medium truncate w-full">
                                                            {accountUser.description}
                                                        </p>
                                                    )
                                                ) : (
                                                    <p className="lg:text-xl text-gray-400">
                                                        {t("account.accountInformation.descriptionMissing")}
                                                    </p>
                                                )}
                                            </div>
                                            <IconChevronUpSVG initialOpen={state.open} spinning={state.spinning} />
                                        </button>

                                        <div className={`grid transition-all duration-300 ease-in-out ${state.open ? 'grid-rows-[1fr] opacity-100 ' : 'grid-rows-[0fr] opacity-0'
                                            }`}>
                                            <div className="overflow-hidden">
                                                <p className="lg:text-xl text-text-700 whitespace-pre-wrap">
                                                    {t(accountUser.description)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <span className="lg:text-xl text-gray-400">{t("account.accountInformation.position")}</span>
                                <p className="lg:text-xl text-text-700">{t(accountUser.position)}</p>

                                <span className="lg:text-xl text-gray-400">{t("account.accountInformation.telephone")}</span>
                                <p className="lg:text-xl text-text-700">{t(accountUser.phone)}</p>

                                <span className="lg:text-xl text-gray-400">{t("account.accountInformation.email")}</span>
                                <p className="lg:text-xl text-text-700">{t(accountUser.email)}</p>

                                <label className="flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 accent-blue-600"
                                    />
                                    <span className=" lg:text-xl text-gray-700">
                                        {t("account.accountInformation.receiveNewsEmail")}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    {renderFooter()}

                    {/* <AccountData
                        title={t("account.userData.dataStorage")}
                        items={["Презентація \"Майбутнє квантових обчислень\"",
                            "Слайди \"Етичні аспекти використання AI\"",
                            "Слайди \"Етичні аспекти використання AI\"",
                            "Протокол тестування нейромереживих моделей",
                            "Презентація \"Майбутнє квантових обчислень\""]}
                        initialOpen={true}
                        typeIcon={FileIconSVG}
                    />
                    <AccountData
                        title={t("account.userData.events")}
                        items={["Вебінар \"Сучасні методи викладання\"",
                            "Конференція \"Освіта 4.0 викладання\"",
                            "Конференція \"Дозвілля 7.0\"",
                            "Вебінар \"Сучасні методи викладання\"",
                            "Конференція \"Освіта 4.0 викладання\""]}
                        initialOpen={true}
                        typeIcon={EventIconSVG}
                    />
                    <AccountData
                        title={t("account.userData.attachedFiles")}
                        items={["Угода про конфіденційність (MDA)",
                            "Сертифікат відповідності ISO 27001",
                            "Ліцензія на використання програмного забезпечення",
                            "Договір на надання освітніх послуг",
                            "Ліцензійна угода на використання SmartTech"]}
                        initialOpen={true}
                        typeIcon={AttachedFileIconSVG}
                    />

                    <div className="w-full lap:w-[210px] xl:w-[360px] md:w-[210px] flex flex-col lap:flex-row lap:justify-between lap:items-center  mt-[10px]">
                        {t("account.buttonText.downloadData") && <Button text={t("account.buttonText.downloadData")} variant={ButtonVariant.DOWNLOAD} />}
                    </div>
                    <button className="w-full flex justify-end text-xl text-red-700 hover:text-red-800 transition-colors">
                        {t("account.buttonText.deleteAccount")}
                    </button> */}
                </>
            )}
        </div>
    );
}
